import React from "react";

import { formatInteger } from "~/utils";
import { HealthBreakdown } from "../Shared";

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

interface StepsBreakdownProps {
  selectedRange: TimeRange;
  filteredData: { x: Date | number; y: number }[];
  breakdownTitle: string;
  loading: boolean;
  error: string | null;
}

export const StepsBreakdown: React.FC<StepsBreakdownProps> = ({
  selectedRange,
  filteredData,
  breakdownTitle,
  loading,
  error,
}) => {
  const getKey = (item: { x: Date | number; y: number }, selectedRange: TimeRange) => {
    return selectedRange === "1d"
      ? String(item.x)
      : item.x instanceof Date
        ? item.x.toISOString()
        : String(item.x);
  };

  const getTimeDisplay = (item: { x: Date | number; y: number }, selectedRange: TimeRange) => {
    if (selectedRange === "1d") {
      return typeof item.x === "number" ? `${item.x}:00` : item.x.toString();
    }

    if (item.x instanceof Date) {
      if (selectedRange === "1y") {
        return item.x.toLocaleDateString("en-US", { month: "long" });
      } else if (selectedRange === "6m") {
        return item.x.toLocaleDateString("en-US", { month: "long" });
      } else {
        return item.x.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        });
      }
    }

    return item.x.toString();
  };

  const getValues = (item: { x: Date | number; y: number }) => [
    {
      label: "Total",
      value: formatInteger(item.y),
      color: "#22c55e", // green-500
      unit: "steps",
    },
  ];

  return (
    <HealthBreakdown
      selectedRange={selectedRange}
      filteredData={filteredData}
      breakdownTitle={breakdownTitle}
      loading={loading}
      error={error}
      dataTypeLabel="Steps Data"
      getKey={getKey}
      getTimeDisplay={getTimeDisplay}
      getValues={getValues}
      noDataMessage="No steps data available"
    />
  );
};
